(() => {
 const storageKey='kd-saved-pieces';
 let saved=[];
 try { saved=JSON.parse(localStorage.getItem(storageKey)||'[]'); if(!Array.isArray(saved))saved=[]; } catch {}
 function refreshSaved() {
  document.querySelectorAll('[data-kd-save]').forEach(button=>button.setAttribute('aria-pressed',String(saved.some(p=>p.id===button.dataset.kdSave))));
  const list=document.querySelector('[data-kd-saved-list]');
  if(!list)return;
  list.replaceChildren();
  const empty=document.querySelector('[data-kd-saved-empty]');if(empty)empty.hidden=saved.length>0;
  saved.forEach(piece=>{
   if(!piece.url?.startsWith('/products/'))return;
   const li=document.createElement('li'),a=document.createElement('a');
   a.href=piece.url;a.textContent=piece.title;li.append(a);list.append(li);
  });
 }
 function hashView(){
  const hash=decodeURIComponent(location.hash.slice(1));
  document.querySelectorAll('[data-kd-detail]').forEach(el=>el.hidden=el.dataset.kdDetail!==(hash||'blue'));
  const color=hash.startsWith('color-')?hash.slice(6):'all';
  document.querySelectorAll('[data-kd-color]').forEach(el=>el.hidden=color!=='all'&&el.dataset.kdColor!==color);
  document.querySelectorAll('[data-kd-color-link]').forEach(el=>el.setAttribute('aria-current',String(el.dataset.kdColorLink===color)));
  if(hash==='by-stone'||hash==='by-size'){const target=document.getElementById(hash);if(target)target.open=true;}
 }
 document.addEventListener('click',event=>{
  const save=event.target.closest('[data-kd-save]');
  if(save){const id=save.dataset.kdSave;const exists=saved.some(p=>p.id===id);saved=exists?saved.filter(p=>p.id!==id):[...saved,{id,title:save.dataset.title,url:save.dataset.url}];try{localStorage.setItem(storageKey,JSON.stringify(saved));}catch{}refreshSaved();}
  const dialog=document.querySelector('[data-kd-saved-dialog]');
  if(event.target.closest('[data-kd-saved-open]')){document.querySelectorAll('.kd-mobile-nav').forEach(el=>el.open=false);dialog?.showModal();}
  if(event.target.closest('[data-kd-saved-close]')||event.target===dialog)dialog?.close();
  if(!event.target.closest('[data-kd-header]'))document.querySelectorAll('.kd-nav-detail,.kd-mobile-nav').forEach(el=>el.open=false);
  if(event.target.closest('.kd-mega a,.kd-mobile-nav nav>a'))document.querySelectorAll('.kd-nav-detail,.kd-mobile-nav').forEach(el=>el.open=false);
 });
 document.addEventListener('toggle',event=>{
  if(event.target.matches?.('.kd-nav-detail')&&event.target.open)document.querySelectorAll('.kd-nav-detail').forEach(el=>{if(el!==event.target)el.open=false;});
 },true);
 document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.kd-nav-detail,.kd-mobile-nav').forEach(el=>el.open=false);});
 addEventListener('hashchange',hashView);
 document.addEventListener('shopify:section:load',()=>{refreshSaved();hashView();});
 refreshSaved();hashView();
})();
